'use client';

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import billieProfile from "../assets/billieProfile.jpg";
import applePie from "../assets/cameraroll/mini-apple-pies.jpeg";
import hanoiFood from "../assets/cameraroll/hanoi food.jpg";
import vanFood from "../assets/cameraroll/van-food.jpeg";
import sunrise from "../assets/cameraroll/sunrise.JPG";
import jellycat from "../assets/cameraroll/jellycat.jpeg";
import dutchIndonesian from "../assets/cameraroll/dutch-indonesian.jpeg";
import banff from "../assets/cameraroll/banff.jpeg";
import sgFood from "../assets/cameraroll/sg-food.jpeg";
import greece from "../assets/cameraroll/greece.JPG";
import shanghaiTower from "../assets/cameraroll/shanghai tower.JPG";
import stanleyPark from "../assets/cameraroll/stanley-park.jpeg";
import hk from "../assets/cameraroll/hk.JPG";
import hkGarden from "../assets/cameraroll/hk-garden.jpg";
import yangzhou from "../assets/cameraroll/yangzhou-garden.JPG";
import vanSunset from "../assets/cameraroll/vancouver-sunset.JPG";
import hike from "../assets/cameraroll/hike.JPG";


const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  const photos = [
    { id: 1, src: banff, label: "banff" },
    { id: 2, src: dutchIndonesian, label: "little sister dutch indonesian" },
    { id: 3, src: jellycat, label: "crochet jellycat" },
    { id: 4, src: sunrise, label: "sunrise" },
    { id: 5, src: applePie, label: "apple pie" },
    { id: 6, src: greece, label: "santorini hike" },
    { id: 7, src: stanleyPark, label: "stanley park sunset" },
    { id: 8, src: sgFood, label: "singapore food" },
    { id: 9, src: hk, label: "hong kong monster buildings" },
    { id: 10, src: hkGarden, label: "hong kong garden" },
    { id: 11, src: hanoiFood, label: "hanoi food" },
    { id: 12, src: yangzhou, label: "yangzhou" },
    { id: 13, src: shanghaiTower, label: "shanghai tower" },
    { id: 14, src: vanSunset, label: "vancouver sunset" },
    { id: 15, src: vanFood, label: "vancouver restaurant" },
    { id: 16, src: hike, label: "hike" },
  ];

  return (
    <section id="about" className="pb-40 pt-52 bg-background text-text">
      <div className="max-w-6xl mx-auto px-8">

        <div className="grid md:grid-cols-12 gap-16 items-center mb-36" data-aos="fade-up">
          <div className="md:col-span-7">
            <h1 className="text-6xl font-bold tracking-tighter mb-10 lowercase text-text">
              hi, i'm billie<span className="text-secondary">.</span>
            </h1>
            <p className="text-xl leading-relaxed font-light text-secondary">
              i'm a builder and a dreamer, currently also a 4th year systems design engineering student at the university of waterloo. <br /> <br />
              i love exploring the space where product strategy meets software development, i'm a fast learner and a big believer in building things that actually help people.
            </p>
          </div>

          <div className="md:col-span-5 relative group">
            <div className="aspect-[8/9] rounded-[3rem] overflow-hidden border border-border shadow-2xl relative z-10">
              <img
                src={billieProfile}
                alt="me"
                className="w-full h-full object-cover scale-105 hover:grayscale hover:scale-100 transition-all duration-700"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-full h-full bg-secondary/5 rounded-[3rem] -z-0" />
          </div>
        </div>


        <div className="grid md:grid-cols-2 gap-32 mb-32 ">
          <div className="space-y-8" data-aos="fade-right">
            <h2 className="text-2xl font-serif italic text-secondary opacity-70 lowercase">recharging</h2>
            <p className="text-lg font-light leading-relaxed text-text opacity-80">
              i love slow days every once in a while, where i can just lose track of time baking my favourite cookies, reading a good book, crocheting a new addition to my closet or going for long walks with friends and family. <br /><br />i also fell in love with running and now i'm training for my first marathon! follow my journey below ↓
            </p>

            <div className="pt-2 space-y-3">
              <div className="flex justify-between items-end">
                <span className="text-[11px] uppercase tracking-widest font-bold text-secondary">Marathon Training progress</span>
                <span className="text-[10px] font-mono text-secondary">57/90 runs completed</span>
              </div>
              <div className="relative w-full h-1.5 bg-border rounded-full overflow-hidden">
                <div className="absolute top-0 left-0 h-full bg-text rounded-full transition-all duration-1000" style={{ width: '58%' }}></div>
              </div>
              <p className="text-[10px] italic text-secondary opacity-60">current phase: building endurance</p>
            </div>
          </div>

          <div className="space-y-10" data-aos="fade-left">
            <h2 className="text-2xl font-serif italic text-secondary opacity-70 lowercase">currently...</h2>
            <div className="grid grid-cols-1 gap-8">
              <div className="flex gap-6 items-start">
                <span className="text-[10px] font-bold text-secondary opacity-40 pt-2">01</span>
                <div>
                  <p className="text-[11px] uppercase tracking-widest font-bold text-secondary mb-2">Learning</p>
                  <p className="text-lg font-light text-text ">📷 photography & japanese!</p>
                </div>
              </div>
              <div className="flex gap-6 items-start">
                <span className="text-[10px] font-bold text-secondary opacity-40 pt-2">02</span>
                <div>
                  <p className="text-[11px] uppercase tracking-widest font-bold text-secondary mb-2">Reading</p>
                  <p className="text-lg font-light text-text ">📖 <span className="italic">Think Like a Monk</span> by Jay Shetty</p>
                </div>
              </div>
              <div className="flex gap-6 items-start">
                <span className="text-[10px] font-bold text-secondary opacity-40 pt-2">03</span>
                <div>
                  <p className="text-[11px] uppercase tracking-widest font-bold text-secondary mb-2">fitness</p>
                  <p className="text-lg font-light text-text">💪🏻 training to get my first pull up</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-20 overflow-hidden">
          <div className="flex items-baseline justify-between mb-10 px-2">
            <h2 className="text-2xl font-serif italic text-secondary lowercase">cameraroll recents</h2>
          </div>

          <div className="overflow-x-auto no-scrollbar cursor-grab active:cursor-grabbing">
            <div className="animate-marquee flex gap-6">
              {photos.map((photo) => (
                <div
                  key={`set1-${photo.id}`}
                  className="min-w-[260px] w-[300px] aspect-[4/5] rounded-[2.5rem] bg-border border border-border overflow-hidden relative group shadow-sm transition-all duration-500"
                >
                  <img src={photo.src} alt={photo.label} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-secondary/5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
                </div>
              ))}
              {/* Duplicate Set for Seamless Loop */}
              {photos.map((photo) => (
                <div
                  key={`set2-${photo.id}`}
                  className="min-w-[260px] w-[300px] aspect-[4/5] rounded-[2.5rem] bg-border border border-border overflow-hidden relative group shadow-sm transition-all duration-500"
                >
                  <img src={photo.src} alt={photo.label} className="w-full h-full object-cover" />

                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center pt-20" data-aos="fade-up">
          <h3 className="text-3xl font-bold tracking-tight mb-8 text-secondary text-center lowercase">
            seeking <span className="font-serif italic text-text"> summer 2027 </span> and <span className="font-serif italic text-text"> new grad </span>opportunities.
          </h3>
          <a
            href="mailto:billie.zhang@uwaterloo.ca"
            className="group flex items-center gap-4 text-xs font-bold uppercase tracking-[0.3em] text-text border-b-2 border-text pb-2 hover:text-secondary hover:border-secondary transition-all duration-300"
          >
            let's build something beautiful
            <span className="transform group-hover:translate-x-2 transition-transform duration-300">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;